import React, {useState,useEffect} from 'react';
import { useTranslate } from 'react-redux-multilingual'
import {CardPerso} from '@gull'
import CodeSectionForm from './Comp/CodeSectionForm'
import axios from 'axios'
import swal from "sweetalert2";

const CodeConfigurationMain = (props) => {
    const t = useTranslate();
    const [disabledValidate,setDisabledValidate] = useState(false)
    const [validButton,setValidButton] = useState(false)
    const [inputMainValue,setInputMainValue] = useState({})//useState qui gère le code, nb section et le chiffre à incrémenter    
    const [sectionCorrespondenceValue,setSectionCorrespondenceValue] = useState({})//Pour la gestion des champs de correspondance liés au select

    const [sectionFieldValue,setSectionFieldValue] = useState({})//Pour la gestion des selects de section 

    useEffect(function () {
        if(props.detailConfig){
            let obj = {
                code:props.detailConfig.config.numero,
                nbrSection:props.detailConfig.config.nombre_section,
                nbrDigitIncrement:props.detailConfig.config.nombre_numero_increment
            }

            if(props.isFor=='client' || props.isFor=='fournisseur') obj['codeDefault']=props.detailConfig.config.default_code ? props.detailConfig.config.default_code : ''

            setInputMainValue(obj)

            let objSectionValue = {}
            let objCorrespondenceValue = {}

            props.detailConfig.config.section.map((section,ind)=>{
                let numeroSection = ind+1

                objSectionValue['section'+numeroSection]=section.field
                let arr = []
                Object.entries(section.value).map(([key,value])=>{
                    if(key=='default'){
                        arr.splice(0,0, {[t('defaultValue')]:value})
                    }else{
                        arr.push({[key]:value})
                    }
                })
                objCorrespondenceValue['section'+numeroSection]= arr
            })

            setSectionFieldValue(objSectionValue)
            setSectionCorrespondenceValue(objCorrespondenceValue)
        }else{
            let obj = {
                code:'',
                nbrSection:'',
                nbrDigitIncrement:''
            }

            if(props.isFor=='client' || props.isFor=='fournisseur') obj['codeDefault']=''

            setInputMainValue(obj)
        }
    }, [props.detailConfig])

    useEffect(function () {
        if(!props.detailConfig){
            let sectionFieldValueObj = {}
            let sectionCorrespondenceValueObj = {}

            if(inputMainValue.nbrSection!=''){
                for (let i=0; i<inputMainValue.nbrSection; i++){
                    let numeroSection = i+1

                    sectionFieldValueObj['section'+numeroSection] = ''
                    sectionCorrespondenceValueObj['section'+numeroSection] = [{}]
                }
            }

            setSectionFieldValue(sectionFieldValueObj)
            setSectionCorrespondenceValue(sectionCorrespondenceValueObj)
        }
    }, [inputMainValue.nbrSection])

    useEffect(function () {
        //Gestion du disabled du bouton valider
        let disabled = false

        //On vérifie si tous les champs principaux sont renseignés
        Object.entries(inputMainValue).map(([key, value])=>{
            if(key!='codeDefault' && value=='') disabled = true
        }) 

        //On vérifie si tous les select sont renseignés
        if(!disabled){
            Object.values(sectionFieldValue).map(field=>{
                if(field=='') disabled = true
            }) 
        }

        //On vérifie si au moins le premier champ de correspondance est renseigné (champ et code)
        if(!disabled){
            Object.values(sectionCorrespondenceValue).map(correspondenceField=>{
                if(Object.keys(correspondenceField[0]).length==0 || Object.keys(correspondenceField[0])[0]=='' || Object.values(correspondenceField[0])[0]=='') disabled = true
            }) 
        }
    
        setDisabledValidate(disabled)

    }, [inputMainValue,sectionCorrespondenceValue,sectionFieldValue])
    
    const handleChange = (e,inputName) => {
        setInputMainValue({...inputMainValue,[inputName]:e.target.value})
    };

    const handleSubmitConf = async () => {
        setValidButton(true)

        let axiosAction = props.detailConfig ? axios.put : axios.post
        let paramUrl = props.detailConfig ? '/'+props.detailConfig.id : ''

        let obj = {
            name:(props.isFor=='fournisseur') ? "code_fournisseur" : "code_client",
            type:props.isFor,
            config : {
                numero:inputMainValue.code,
                nombre_section:inputMainValue.nbrSection,
                nombre_numero_increment:inputMainValue.nbrDigitIncrement,
            }
        }

        if(props.idCompany!='company') obj["other_company"]=props.idCompany
        if(props.isFor=='client' || props.isFor=='fournisseur') obj.config['default_code']=inputMainValue.codeDefault

        let arrCorrespondenceField = []
        Object.entries(sectionFieldValue).map(([keySection,valueSelect],index)=>{
            //Si configuration existante et qu'on modifie la nombre de section, ex : 2 section à 3 et qu'on valide, on enverra les datas que pour 1 section
            if(index+1 <= +inputMainValue.nbrSection){
                let obj = {
                    field : valueSelect,
                    value : {}
                }
                sectionCorrespondenceValue[keySection].map((correpondenceFileds,ind)=>{
                    const key = Object.keys(correpondenceFileds)[0]; // Récupère la clé
                    const value = correpondenceFileds[key]; // Récupère la valeur
                    if(ind==0){
                        obj.value['default']=value
                    }else{
                        obj.value[key]=value
                    }
                })
    
                arrCorrespondenceField.push(obj)
            }
        })
        obj.config['section'] = arrCorrespondenceField
        
        const response = await axiosAction(process.env.REACT_APP_API_URL+"api/compta/compta_field_config"+paramUrl, obj
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            }else{
                setValidButton(false)
                props.setReload(Date.now())
            }
        }).catch((error) => {
            if(error=='end_session') return;
            if(error.response==undefined){
                swal.fire(t('unknowError'), "", "error");
            }
            else if(error.response.status==403){
                swal.fire(t('forbiddenGeneral'), "", "error");
            }
            else {
                swal.fire(t('unknowError'), "", "error");
            }
            setValidButton(false)
        })
    };

    return(
        <>
            <CardPerso header={<span className='d-flex justify-content-between'>
                <span>{(props.isFor=='fournisseur') ? t('codeConfigurationFournisseur') : t('codeConfigurationClient')}</span>
                <button 
                    disabled={disabledValidate || validButton} 
                    className='btn btn-primary' 
                    onClick={()=>handleSubmitConf()}
                >
                    {validButton ? <div className="spinner-border spinner-border-sm"></div> : t('btnValidate')}
                </button>
            </span>}>
                {/* Select pour match code comptable fournisseur par defaut */}
                {props.isFor=='fournisseur' && 
                    <div className="row mb-1">
                            <div className="col-12 col-md-4 form-group">
                                <label>{t('codeFournisseurDefault')}</label> 
                                <select disabled={validButton} value={Object.keys(inputMainValue).length!=0 ? inputMainValue.codeDefault : ''} className='form-control' onChange={(e)=>handleChange(e,'codeDefault')}>
                                    <option value="">-- Select --</option>
                                    {props.datas.map(dataField=>{
                                        if (dataField.name=='name') return
                                        else {
                                            return(
                                                <option key={dataField.name} value={dataField.name}>{
                                                    dataField.name=='name' ? t('providerName') : 
                                                    t(dataField.name) ? t(dataField.name) :
                                                    dataField.name
                                                }</option>
                                            )
                                        }
                                    })}
                                </select>
                            </div>
                    </div>
                }
                <div className="row mb-1">
                    {props.isFor=='client' && 
                        <div className="col-12 col-md-3 form-group">
                            <label>{t('codeClientDefault')}</label> 
                            <input disabled={validButton} value={Object.keys(inputMainValue).length!=0 ? inputMainValue.codeDefault : ''} type="text" className='form-control' onChange={(e)=>handleChange(e,'codeDefault')}/>
                        </div>
                    }
                    <div className={`${props.isFor=='client' ? "col-12 col-md-3" : "col-12 col-md-4" } form-group`}>
                        <label>{(props.isFor=='fournisseur') ? t('codeFournisseur') : t('codeClient')}</label> 
                        <input disabled={validButton} value={Object.keys(inputMainValue).length!=0 ? inputMainValue.code : ''} type="text" className='form-control' onChange={(e)=>handleChange(e,'code')}/>
                    </div>
                    <div className={`${props.isFor=='client' ? "col-12 col-md-3" : "col-12 col-md-4" } form-group`}>
                        <label>{t('numberOfSection')}</label> 
                        <input disabled={validButton} value={Object.keys(inputMainValue).length!=0 ? inputMainValue.nbrSection : ''} type="number" className='form-control' onChange={(e)=>handleChange(e,'nbrSection')}/>
                    </div>
                    <div className={`${props.isFor=='client' ? "col-12 col-md-3" : "col-12 col-md-4" } form-group`}>
                        <label>{t('numberOfDigitsToIncrement')}</label> 
                        <input disabled={validButton} value={Object.keys(inputMainValue).length!=0 ? inputMainValue.nbrDigitIncrement : ''} type="number" className='form-control' onChange={(e)=>handleChange(e,'nbrDigitIncrement')}/>
                    </div>
                </div>
            </CardPerso>
            {(inputMainValue.nbrSection!='' && Object.keys(sectionCorrespondenceValue).lenght!=0) &&
                <CodeSectionForm 
                    nbrSection={inputMainValue.nbrSection}
                    sectionFieldValue={sectionFieldValue}
                    setSectionFieldValue={setSectionFieldValue}

                    sectionCorrespondenceValue={sectionCorrespondenceValue}
                    setSectionCorrespondenceValue={setSectionCorrespondenceValue}
                    datas={props.datas}
                    isFor={props.isFor}
                    allClientType={props.allClientType}
                    validButton={validButton}
                />
            }
        </>
    )
}

export default CodeConfigurationMain;